export default "__VITE_ASSET__DSuViqL7__"